import React from "react";
import "./Scss/App.scss";
import Home from "./Pages/Home";

function App() {
  return (
    <div className="App">
      <Home />
    </div>
  );
}

export default App;
